export default __webpack_public_path__ + "static/media/OpenSans-Regular.ca49d2b0.ttf";